import { useState } from 'react';
import { Layout } from 'lucide-react';
import { TEMPLATES } from '../../lib/designer/templates';

function TemplateGallery({ onApply, onClose }) {
  const [selected, setSelected] = useState(null);

  function handleApply() {
    const tpl = TEMPLATES.find((t) => t.id === selected);
    if (tpl) {
      onApply(tpl);
      onClose();
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={onClose}
    >
      <div
        className="max-w-2xl w-full bg-white dark:bg-gray-800 rounded-lg shadow-xl p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-2 mb-4">
          <Layout className="h-5 w-5 text-teal-500" />
          <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
            Template Gallery
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
          {TEMPLATES.map((tpl) => (
            <button
              key={tpl.id}
              type="button"
              onClick={() => setSelected(tpl.id)}
              className={`text-left p-4 rounded-lg border-2 transition-colors ${
                selected === tpl.id
                  ? 'border-teal-500 bg-teal-50 dark:bg-teal-900/20'
                  : 'border-gray-200 dark:border-gray-700 hover:border-teal-300 dark:hover:border-teal-700'
              }`}
            >
              <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                {tpl.name}
              </p>
              <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                {tpl.description}
              </p>
              <p className="mt-2 text-xs text-gray-400 dark:text-gray-500">
                {tpl.nodes.length} node{tpl.nodes.length !== 1 ? 's' : ''} &middot; {tpl.edges.length} edge{tpl.edges.length !== 1 ? 's' : ''}
              </p>
            </button>
          ))}
        </div>

        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="h-8 px-4 text-xs border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleApply}
            disabled={!selected}
            className="h-8 px-4 text-xs bg-teal-500 text-white rounded hover:bg-teal-600 disabled:opacity-50 transition-colors"
          >
            Apply Template
          </button>
        </div>
      </div>
    </div>
  );
}

export default TemplateGallery;
